document.querySelectorAll('.ToggleBoolean').forEach(ToggleBooleanInit)

function ToggleBooleanInit(el) {
    checkInit(el,() => {
        const inputs = Array.from(el.querySelectorAll('input'));
        el.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            const input = el.querySelector('input:not(:checked)');
            input.checked = true;
            input.dispatchEvent(new CustomEvent('change'));
            checkActive();
        }, { capture: true });

        inputs.forEach((input) => {
            input.addEventListener('change', checkActive);
        })

        checkActive();
        function checkActive() {
            const i = inputs.findIndex((input) => input.checked);
            el.classList.toggle('ToggleBoolean--active', i === 1);
        }
    }, 'data-boolean-inited');
}
